import { FormattedMessage } from "react-intl";
import {
  CanceledOrderDetails,
  CreatedOrderDetails,
} from "../../../models/order.interface";
import { utcStringToFormattedLocalDateString } from "../../../utils/dateUtil";
import ApprovedIcon from "../../Shared/ApprovedIcon/ApprovedIcon";
import { Button, Modal } from "@shltelemedicine/shl-ui-lib";
import OrderCanceledIcon from "../../Shared/OrderCanceledIcon/OrderCanceledIcon";
import OrderCreatedIcon from "../../Shared/OrderCreatedIcon/OrderCreatedIcon";
import styles from "./OrderModal.module.css";

type OrderModalProps = {
  orderDetails: CreatedOrderDetails | CanceledOrderDetails;
  show?: boolean;
  onClose?: () => void;
  mode: "canceled" | "created";
};

const OrderModal = ({ orderDetails, show, onClose, mode }: OrderModalProps) => {
  const {
    orderNumber,
    studyName,
    subjectId,
    createdDetails: { salutation, date: createdDate, firstName, lastName },
  } = orderDetails;

  return (
    <Modal
      show={show}
      centered
      backdrop="static"
      dialogClassName=""
      contentClassName="h-100 app-shadow"
      onHide={onClose}
      header={
        <div className="d-flex align-items-center">
          {mode === "canceled" && (
            <>
              <OrderCanceledIcon />
              <span className="mx-1" />
              <FormattedMessage
                id="ORDERS.ORDER_CANCELED"
                defaultMessage={"Order Canceled"}
              />
            </>
          )}
          {mode === "created" && (
            <>
              <OrderCreatedIcon />
              <span className="mx-1" />
              <FormattedMessage
                id="ORDERS.ORDER_CREATED"
                defaultMessage={"Order Created"}
              />
            </>
          )}
        </div>
      }
      footer={
        <div className="d-flex justify-content-end pt-2 border-top">
          <Button
            bgColor="transparent linear-gradient(180deg, #505F95 0%, #2C449A 100%) 0% 0% no-repeat padding-box"
            className="align-self-end capitalized"
            onClick={onClose}
          >
            <FormattedMessage id="GLOBAL.OK" defaultMessage="OK" />
          </Button>
        </div>
      }
    >
      <div className={styles.modalBody}>
        <FormattedMessage
          id={
            mode === "canceled"
              ? "ORDERS.ORDER_CANCELED.CANCELED_ORDER"
              : mode === "created"
              ? "ORDERS.ORDER_CREATED.NEW_ORDER_CREATED"
              : undefined
          }
          defaultMessage={
            mode === "canceled"
              ? "Canceled order"
              : mode === "created"
              ? "New order created"
              : undefined
          }
        />
        &nbsp;
        {mode === "canceled" && <span>{orderNumber}</span>}
        <div className="d-flex my-4">
          <ApprovedIcon />
          <div className={`${styles.orderDetails} mx-3`}>
            <div>
              <FormattedMessage id="ORDERS.STUDY" defaultMessage="Study" />
              &nbsp;
              <span>{studyName}</span>
            </div>
            <div>
              <FormattedMessage id="ORDERS.SUBJECT_ID" defaultMessage="Study" />
              &nbsp;
              <span>{subjectId}</span>
            </div>
          </div>
        </div>
        <div className={styles.orderHistoryDetails}>
          <div>
            <FormattedMessage
              id="ORDERS.ORDER_CREATED.DETAILS"
              defaultMessage="Creation date: {createdDate} <br></br>by {salutation} {firstName} {lastName}"
              values={{
                br: () => <br></br>,
                createdDate: utcStringToFormattedLocalDateString(
                  createdDate ?? ""
                ),
                salutation: salutation,
                firstName: firstName,
                lastName: lastName,
              }}
            />
          </div>
          {mode === "canceled" &&
            (orderDetails as CanceledOrderDetails).canceledDetails && (
              <div>
                <FormattedMessage
                  id="ORDERS.ORDER_CANCELED.DETAILS"
                  defaultMessage="Cancelation date: {createdDate} <br></br>by {salutation} {firstName} {lastName}"
                  values={{
                    br: () => <br></br>,
                    createdDate: utcStringToFormattedLocalDateString(
                      (orderDetails as CanceledOrderDetails).canceledDetails
                        .date ?? ""
                    ),
                    salutation: (orderDetails as CanceledOrderDetails)
                      .canceledDetails.salutation,
                    firstName: (orderDetails as CanceledOrderDetails)
                      .canceledDetails.firstName,
                    lastName: (orderDetails as CanceledOrderDetails)
                      .canceledDetails.lastName,
                  }}
                />
              </div>
            )}
        </div>
      </div>
    </Modal>
  );
};

export default OrderModal;
